export const INF_LICENCE_ENDED_AT = new Date('2125-01-01T00:00:00+00:00'); // ended at date from backend for infinite licence
